import { SampleCustom } from "../../../sampleType/models/sampleForm/SampleCustom";

export interface PatientDataField {
  key: string
  odooField: string
  value: any
}

export type PatientCustomProps = {
  _id: string | undefined
  _firstName: string
  _lastName: string
  _nhc: string
  _clinicHistory: string
  _patientData: PatientDataField[]
  _sample: SampleCustom
}

export class PatientCustom {
  _id: string | undefined
  _firstName: string
  _lastName: string
  _nhc: string
  _clinicHistory: string
  _patientData: PatientDataField[]
  _sample: SampleCustom

  constructor(p: PatientCustomProps) {
    this._id = p._id
    this._firstName = p._firstName
    this._lastName = p._lastName
    this._nhc = p._nhc
    this._clinicHistory = p._clinicHistory
    this._patientData = p._patientData
    this._sample = p._sample
  }

  get id(): string | undefined { return this._id }
  set id(value: string | undefined) { this._id = value }
  get firstName(): string { return this._firstName }
  set firstName(value: string) { this._firstName = value }
  get lastName(): string { return this._lastName }
  set lastName(value: string) { this._lastName = value }
  get nhc(): string { return this._nhc }
  set nhc(value: string) { this._nhc = value }
  get clinicHistory(): string { return this._clinicHistory }
  set clinicHistory(value: string) { this._clinicHistory = value }
  get patientData(): PatientDataField[] { return this._patientData }
  set patientData(value: PatientDataField[]) { this._patientData = value }
  get sample(): SampleCustom { return this._sample }
  set sample(value: SampleCustom) { this._sample = value }

  getFieldValue(key: string): any {
    const field = this._patientData.find(f => f.key === key)
    return field?.value
  }

  setFieldValue(key: string, value: any, odooField?: string): void {
    const existing = this._patientData.find(f => f.key === key)
    if (existing) {
      existing.value = value
      if (odooField !== undefined) existing.odooField = odooField
    } else {
      this._patientData.push({ key, odooField: odooField ?? '', value })
    }
  }

  getOdooField(key: string): string {
    const field = this._patientData.find(f => f.key === key)
    return field?.odooField ?? ''
  }
}
